import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ConfirmDeleteModal } from "@eudonet/opal";
import SaveAdvancedFilterModal from "./SaveAdvancedFilterModal.vue";
import RenameAdvancedFilterModal from "./RenameAdvancedFilterModal.vue";
import ManageFilterAccessModal from "./ManageFilterAccessModal.vue";
/**
 * The modals every saved-filter lifecycle needs: save, rename, delete-confirm, manage access.
 *
 * `useSavedFilterLifecycle` already shares the state and the handlers between the contact
 * and organisation lists, but the ~18 template bindings that wire them up were copied
 * verbatim into both views — so every fix had to be applied twice and kept in sync, and each
 * new modal (OP-6513 adds one) had to be added twice. Binding lives here instead; a view
 * calls `useSavedFilterLifecycle` and passes the result down.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'SavedFilterLifecycleModals',
    props: {
        lifecycle: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(SaveAdvancedFilterModal, {
                    "model-value": props.lifecycle.saveModalOpen.value,
                    busy: props.lifecycle.savePending.value,
                    "error-message": props.lifecycle.saveError.value,
                    "onUpdate:modelValue": props.lifecycle.setSaveModalOpen,
                    onSave: props.lifecycle.onSaveConfirmed
                }, null, 8 /* PROPS */, ["model-value", "busy", "error-message", "onUpdate:modelValue", "onSave"]),
                _createVNode(RenameAdvancedFilterModal, {
                    "model-value": props.lifecycle.renameTarget.value !== null,
                    "current-name": props.lifecycle.renameTarget.value?.name ?? '',
                    busy: props.lifecycle.renamePending.value,
                    "error-message": props.lifecycle.renameError.value,
                    "onUpdate:modelValue": props.lifecycle.closeRenameModal,
                    onRename: props.lifecycle.onRenameConfirmed
                }, null, 8 /* PROPS */, ["model-value", "current-name", "busy", "error-message", "onUpdate:modelValue", "onRename"]),
                _createVNode(ManageFilterAccessModal, {
                    "model-value": props.lifecycle.manageTarget.value !== null,
                    sharing: props.lifecycle.manageSharing.value,
                    "known-users": props.lifecycle.manageKnownUsers.value,
                    loading: props.lifecycle.manageLoading.value,
                    "load-error": props.lifecycle.manageLoadError.value,
                    busy: props.lifecycle.managePending.value,
                    "error-message": props.lifecycle.manageError.value,
                    "onUpdate:modelValue": props.lifecycle.closeManageModal,
                    onSave: props.lifecycle.onManageAccessConfirmed
                }, null, 8 /* PROPS */, ["model-value", "sharing", "known-users", "loading", "load-error", "busy", "error-message", "onUpdate:modelValue", "onSave"]),
                _createVNode(_unref(ConfirmDeleteModal), {
                    "model-value": props.lifecycle.deleteModalOpen.value,
                    title: _ctx.$t('advancedFilterLibrary.delete.title'),
                    subtitle: _ctx.$t('advancedFilterLibrary.delete.subtitle', { name: props.lifecycle.deleteTarget.value?.name ?? '' }),
                    "confirm-label": _ctx.$t('advancedFilterLibrary.delete.confirm'),
                    "cancel-label": _ctx.$t('advancedFilterLibrary.delete.cancel'),
                    "onUpdate:modelValue": props.lifecycle.closeDeleteModal,
                    onCancel: props.lifecycle.onDeleteCancelled,
                    onConfirm: props.lifecycle.onDeleteConfirmed
                }, null, 8 /* PROPS */, ["model-value", "title", "subtitle", "confirm-label", "cancel-label", "onUpdate:modelValue", "onCancel", "onConfirm"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
